import { render } from "./GoBack.vue?vue&type=template&id=1e11ff4f&scoped=true"
import script from "./GoBack.vue?vue&type=script&lang=js"
export * from "./GoBack.vue?vue&type=script&lang=js"

import "./GoBack.vue?vue&type=style&index=0&id=1e11ff4f&scoped=true&lang=css"

import exportComponent from "F:\\XAMPP_NEW\\htdocs\\ASRHAVELI\\delivery\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e11ff4f"]])

export default __exports__